import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import DraggableModal from '../DraggableModal';

export default function ModalSingleInput({
  onClose, onConfirm, header, label, placeholder,
}) {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  const headerContent = header || 'Введите значение';
  const _placeholder = placeholder || 'Введите значение';

  const handleConfirm = async () => {
    setLoading(true);
    const success = await onConfirm(value);
    if (success) onClose();
    setLoading(false);
  };

  return (
    <DraggableModal show headerNode={headerContent} onHide={onClose}>

      <Modal.Body>
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Control
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={_placeholder}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} variant="outline-secondary" disabled={loading}>Отмена</Button>
        <Button onClick={handleConfirm} variant="outline-primary" disabled={loading}>OK</Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
